export default {
    BRAZE_ALIAS: 'braze-alias',
    DEVICE_TOKEN: 'device-token',
    MARKETING_USER_ID: 'marketing-user-id',
    MARKETING_CONTENT_CARD_SESSION: 'marketing-content-card-session'
};
